module.exports = __webpack_public_path__ + "static/media/素咕咾肉.efc676c2.jpg";